
const hostName = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_HOST_PROD:process.env.REACT_APP_HOST_TEST;

export default {

	hostName: hostName,
    receipts: hostName + "/dof-api/guest/cust/receipts",
	services: hostName + "/dof-api/guest/cust/services",
    serviceItems: hostName + "/dof-api/guest/cust/service-items",
    departments: hostName + "/dof-api/guest/cust/departments",
    payments: hostName + "/dof-api/guest/cust/payments",
    orders: hostName + "/dof-api/guest/cust/orders",
    users: hostName + "/dof-api/guest/cust/users",
    references: hostName + "/dof-api/guest/cust/references",
    refKinds: hostName + "/dof-api/guest/cust/ref/kinds",
    reports: hostName + "/dof-api/guest/cust/reports/report",
    provinces: hostName + "/dof-api/guest/cust/provinces",
    regions: hostName + "/dof-api/guest/cust/regions",
};
